'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var InternalSnackbar_web = require('../../internal/InternalSnackbar/InternalSnackbar.web.cjs');
var snackbarStore = require('./snackbarStore.cjs');

/**
 * Snackbar component that automatically manages notifications using Zustand.
 * This is the main component you should use in your app.
 * Mount this once at your app root level.
 *
 * {@link https://aviary.fullscript.io/latest/components/snackbar/web-MEMTPTxQ | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/molecules/Snackbar/Snackbar.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const Snackbar = ({ position = "bottomRight" })=>{
    const { messages, removeMessage } = snackbarStore.useSnackbarStore();
    return /*#__PURE__*/ jsxRuntime.jsx(InternalSnackbar_web.InternalSnackbar, {
        position: position,
        messages: messages,
        onRemoveMessage: removeMessage
    });
};

exports.Snackbar = Snackbar;
//# sourceMappingURL=Snackbar.web.cjs.map
